const FilesIcon = ({ fill = "#2BB792" }: any) => (
    <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.068 6H12l-1.434-1.434A1.932 1.932 0 0 0 9.2 4H3.932A1.932 1.932 0 0 0 2 5.932v12.136C2 19.135 2.865 20 3.932 20h16.136A1.932 1.932 0 0 0 22 18.068V7.932A1.932 1.932 0 0 0 20.068 6Zm-8.075 6.5a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Zm-1.338 1.14A3.408 3.408 0 0 1 12 13.364c.931 0 1.825.383 2.483 1.065.492.51.823 1.154.96 1.85.076.393-.256.721-.656.721H9.213c-.4 0-.733-.328-.656-.72.136-.697.467-1.342.959-1.851a3.507 3.507 0 0 1 1.14-.789Z"
            fill={fill}
        />
    </svg>
)

export default FilesIcon
